import React from "react";

const SignedIcon = () => {
  return (
    <div>
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.8544 7.4345L6.5029 7.079C6.4247 7.1563 6.37418 7.2572 6.35913 7.3661L6.8544 7.4345ZM8.981 9.6335L9.0541 10.1281C9.1634 10.112 9.2643 10.0601 9.341 9.9805L8.981 9.6335ZM6.5 10L6.0047 9.9316C5.98316 10.0875 6.03629 10.2444 6.14811 10.3552C6.25992 10.466 6.41736 10.5176 6.5731 10.4946L6.5 10ZM4.5 12.5C4.77614 12.5 5 12.2761 5 12C5 11.7238 4.77614 11.5 4.5 11.5V12.5ZM16.5 16.5C16.7761 16.5 17 16.2761 17 16C17 15.7238 16.7761 15.5 16.5 15.5V16.5ZM7.206 7.7901L13.7945 1.27557L13.0914 0.564483L6.5029 7.079L7.206 7.7901ZM15.1 2.5645L8.621 9.2865L9.341 9.9805L15.82 3.25847L15.1 2.5645ZM8.9079 9.1389L6.42693 9.5054L6.5731 10.4946L9.0541 10.1281L8.9079 9.1389ZM6.9953 10.0684L7.3497 7.503L6.35913 7.3661L6.0047 9.9316L6.9953 10.0684ZM15.0383 1.23294C15.4373 1.57678 15.4655 2.18525 15.1 2.5645L15.82 3.25847C16.584 2.46581 16.5251 1.19404 15.6911 0.475393L15.0383 1.23294ZM13.7945 1.27557C14.1346 0.939293 14.676 0.920733 15.0383 1.23294L15.6911 0.475393C14.9338 -0.177157 13.8022 -0.138377 13.0914 0.564483L13.7945 1.27557ZM4.5 11.5H2.5V12.5H4.5V11.5ZM2.5 16.5H16.5V15.5H2.5V16.5ZM0 14C0 15.3807 1.11929 16.5 2.5 16.5V15.5C1.67157 15.5 1 14.8284 1 14H0ZM2.5 11.5C1.11929 11.5 0 12.6193 0 14H1C1 13.1716 1.67157 12.5 2.5 12.5V11.5Z"
          fill="#111827"
        />
      </svg>
    </div>
  );
};

export default SignedIcon;
